"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPickerInput = exports.isValid = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const Space_1 = require("../../3-list-item/Space");
const ColorPicker_1 = require("../../4-card/ColorPicker");
const InputColor_1 = require("../../2-inline-block/InputColor");
const color_1 = require("../../styles/color");
const REG_VALID = /^#?([0-9A-F]{3}|([0-9A-F]{6}([0-9a-f]{2})?))$/i;
const isValid = (color) => {
    return REG_VALID.test(color);
};
exports.isValid = isValid;
const ColorPickerInput = ({ input, ...rest }) => {
    const [t] = (0, use_t_1.useT)();
    const color = rest.color;
    return (React.createElement("div", { style: { minWidth: 'calc(min(240px, 100vw))' } },
        React.createElement(InputColor_1.InputColor, { label: t('Color'), ...input, value: typeof color === 'string' ? color : color?.toRgb().hex() || '', onChange: (v) => {
                if ((0, exports.isValid)(v)) {
                    rest.onChange?.(color_1.HslColor.from(v) ?? color_1.HslColor.from('#000000'));
                }
            } }),
        React.createElement(Space_1.Space, null),
        React.createElement(ColorPicker_1.ColorPicker, { style: { width: '100%' }, ...rest })));
};
exports.ColorPickerInput = ColorPickerInput;
